import React from "react";
import styled from "styled-components";

const FormButtonPrimary = ({ children, size, disabled, bgColor, bgColorHover, ...props }) => {

  if (size === "extraSmall") {
    return (
      <ButtonPrimaryExtraSmall $disabled={disabled} disabled={disabled} $bgColor={bgColor} $bgColorHover={bgColorHover} {...props}>
        {children}
      </ButtonPrimaryExtraSmall>
    );
  }

  if (size === "small") {
    return (
      <ButtonPrimarySmall $disabled={disabled} disabled={disabled} $bgColor={bgColor} $bgColorHover={bgColorHover} {...props}>
        {children}
      </ButtonPrimarySmall>
    );
  }

  return (
    <ButtonPrimary $disabled={disabled} disabled={disabled} $bgColor={bgColor} $bgColorHover={bgColorHover} {...props}>
      {children}
    </ButtonPrimary>
  );
};

const ButtonPrimary = styled.button`
  flex-shrink: 0;
  padding: 11px 60px;
  color: var(--aia-bx-white);
  background-color: ${props => props.$bgColor};
  border-radius: 100px;
  border: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  justify-content: center;

  display: flex;
  align-items: center;

  ${props => props.$disabled ? `
      cursor: not-allowed;
      background-color: var(--aia-bx-gray-5);
      border-color: var(--aia-bx-gray-5);
      color: var(--aia-bx-gray-4);
    `
    :
    `
    &:hover {
      background-color: ${props.$bgColorHover};
    }
  `};
`;

const ButtonPrimarySmall = styled.button`
  flex-shrink: 0;
  padding: 8px 30px;
  color: var(--aia-bx-white);
  background-color: ${props => props.$bgColor};
  border-radius: 100px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  line-height: 24px;
  font-weight: bold;
  justify-content: center;

  display: flex;
  align-items: center;

  ${props => props.$disabled ? `
      cursor: not-allowed;
      background-color: var(--aia-bx-gray-5);
      border-color: var(--aia-bx-gray-5);
      color: var(--aia-bx-gray-4);
    `
    :
    `
    &:hover {
      background-color: ${props.$bgColorHover};
    }
  `};
`;

const ButtonPrimaryExtraSmall = styled.button`
  flex-shrink: 0;
  padding: 5px 20px;
  color: var(--aia-bx-white);
  background-color: ${props => props.$bgColor};
  border-radius: 100px;
  border: none;
  cursor: pointer;
  font-size: 14px;
  line-height: 24px;
  font-weight: bold;
  justify-content: center;

  display: flex;
  gap: 8px;
  align-items: center;

  ${props => props.$disabled ? `
      cursor: not-allowed;
      background-color: var(--aia-bx-gray-5);
      border-color: var(--aia-bx-gray-5);
      color: var(--aia-bx-gray-4);
    `
    :
    `
    &:hover {
      background-color: ${props.$bgColorHover};
    }
  `};
`;

ButtonPrimary.defaultProps = {
  $bgColor: "var(--aia-bx-blue-2)",
  $bgColorHover: "var(--aia-bx-blue-6)",
}

ButtonPrimarySmall.defaultProps = {
  $bgColor: "var(--aia-bx-blue-2)",
  $bgColorHover: "var(--aia-bx-blue-6)",
}

ButtonPrimaryExtraSmall.defaultProps = {
  $bgColor: "var(--aia-bx-blue-2)",
  $bgColorHover: "var(--aia-bx-blue-6)",
}

export default FormButtonPrimary;